const relations = [
  { name: "Partner", value: "partner" },
  { name: "Sibling", value: "sibling" },
  { name: "Child", value: "child" },
  { name: "Parent", value: "parent" },
  { name: "Guardian", value: "guardian" },
  { name: "Grandparent", value: "grandparent" },
  { name: "Grandchild", value: "grandchild" },
  { name: "Cousin", value: "cousin" },
  { name: "Other adult", value: "other_adult" },
  { name: "Other relative", value: "other_relative" }
];

export default relations;
